export const PARTICIPANT_DND_TYPE = 'participant-dnd';

export const PARTICIPANT_STATUS = {
	PARTICIPATING: 'participating',
	NOT_PARTICIPATING: 'not-participating',
	UNASSIGNED: 'unassigned',
} as const;
